import React from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';

export default function HowToRead() {
  return (
    <Accordion disableGutters variant="outlined">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle2">How to read this page</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack component="ul" spacing={1} sx={{ m: 0, pl: 3 }}>
          <Typography component="li" variant="body2">
            A hotel on this list is eligible for a boost. It is not a record of what a search showed.
          </Typography>
          <Typography component="li" variant="body2">
            Start and End are the boost window for LPC rows. LPP boost rows have no window.
          </Typography>
          <Typography component="li" variant="body2">
            Impressions 7d and Sales 7d cover the last 7 days. Lifetime impressions is the running total the 3,000
            impression cap checks. All counts are for the offer itself.
          </Typography>
          <Typography component="li" variant="body2">
            The data comes straight from the search index and is cached for 5 minutes.
          </Typography>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
